"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = MultiValue;
var React = _interopRequireWildcard(require("react"));
var _overrides = require("../helpers/overrides");
var _tag = require("../tag");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); } /*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function MultiValue(props) {
  const {
    overrides = {},
    removeValue,
    ...restProps
  } = props;
  // todo(v11): remove the MultiValue override in favor of Tag
  const [MultiValue, tagProps] = (0, _overrides.getOverrides)(overrides.Tag || overrides.MultiValue, _tag.Tag);
  return /*#__PURE__*/React.createElement(MultiValue, _extends({
    hierarchy: _tag.HIERARCHY.primary,
    overrides: {
      Root: {
        // @ts-ignore
        style: ({
          $theme: {
            sizing
          }
        }) => ({
          marginRight: sizing.scale0,
          marginBottom: sizing.scale0,
          marginLeft: sizing.scale0,
          marginTop: sizing.scale0
        })
      }
    },
    onActionClick: removeValue
  }, restProps, tagProps), props.children);
}